import React from 'react';
import { plural } from '@lingui/core/macro';

import MediaBlock from '@rover/components/src/MediaBlock';
import { Text } from '@rover/kibble/core';
import type { Pet } from '@rover/rsdk/src/apiClient/latest/model/pet';
import type { UnitEnum } from '@rover/rsdk/src/apiClient/latest/model/unitEnum';

type Props = {
  pet: Pet;
  weightLabel: UnitEnum;
  onPetPressed?: (pet: Pet) => void;
  dataTestId?: string;
};

const PetBlock = ({ pet, weightLabel, onPetPressed, dataTestId }: Props): JSX.Element => {
  const handleOnClick = onPetPressed ? () => onPetPressed(pet) : undefined;

  const convertWeight = (): number | string => {
    let { weight } = pet;
    const weightObj = pet.weightObj.find((item) => item.unit === weightLabel);
    weight = weightObj ? parseInt(weightObj.value, 10) : pet.weight;
    return weight;
  };

  const years = plural(pet.ageYears, {
    one: `, ${pet.ageYears} year,`,
    other: `, ${pet.ageYears} years,`,
  });
  const months = plural(pet.ageMonths, {
    one: `${pet.ageMonths} month`,
    other: `${pet.ageMonths} months`,
  });

  const weightAndAge = `${convertWeight()} ${weightLabel}${years} ${months}`;

  const breed = pet.breeds ? pet.breeds[0] : '';

  return (
    <MediaBlock
      title={pet.name}
      subtitle={breed}
      graphic={pet.defaultImage.bigThumb}
      onClick={handleOnClick}
      role="link"
      rounded
      ariaLabel={`${pet.name}, ${breed}, ${weightAndAge}`}
      dataTestId={dataTestId}
    >
      <Text textColor="tertiary">{weightAndAge}</Text>
    </MediaBlock>
  );
};
export default PetBlock;
